import React from 'react';
import styled from 'styled-components';
import './lectura.css'; // Importa el archivo CSS 
import imagen from './Imagenes/LOGOS SEP-USICAMM_JUNTOS.png';

const ImagenTitulo = styled.img`
    width: 60%; /* La imagen es un 30% más pequeña */
    margin-bottom: 20px; /* Puedes ajustar el valor según sea necesario */
    margin-left:5%;
    margin-top: 20px; /* Puedes ajustar el valor según sea necesario */
    @media (max-width: 768px) {
        margin-left: 0; /* Elimina el margen izquierdo en pantallas pequeñas */
        width: 92%; /* Ocupa todo el ancho del contenedor en pantallas pequeñas */
    }

`;

const ContenedorTitulo = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 3.5%; /* Espacio del 10% a la izquierda */

`;
 

const Titulo = () => {
    return ( 
        <>
        
         <ContenedorTitulo>
                <ImagenTitulo src={imagen} alt="Ejemplo" />
             
            </ContenedorTitulo>
        
        </>
        
     );
}
 
export default Titulo;
  

